import { defaultInstance } from "./instances";

export const fetch = async (type: "specialization" | "direction" | "scope"): Promise<any> =>
  await defaultInstance.get<any>(`/tag/${type}/list`);
